<div class="whole-container">
    <router-outlet></router-outlet>
</div>
